import * as React from 'react';
import {
  getHiddenUnicodeCharacters,
  removeHiddenUnicodeCharacters,
} from '@web-config-app/core';

export const useHiddenUnicodeWarning = ({
  value,
  path,
  onChange,
  enabled = true,
}: {
  value: string;
  path: string;
  onChange: (path: string, nextValue: string | undefined) => void;
  enabled?: boolean;
}) => {
  const hiddenCharacters = React.useMemo(
    () => getHiddenUnicodeCharacters(value),
    [value],
  );

  const hasHiddenCharacters = hiddenCharacters.length > 0;

  const removeHiddenCharacters = React.useCallback(() => {
    if (!enabled) {
      return;
    }

    const cleanedValue = removeHiddenUnicodeCharacters(value);
    if (cleanedValue.trim().length < 1) {
      onChange(path, undefined);
    } else {
      onChange(path, cleanedValue);
    }
  }, [enabled, onChange, path, value]);

  return {
    hasHiddenCharacters,
    removeHiddenCharacters,
  };
};
